module.exports =(function() {
  return function(context) {
    return (function() {
      var $c, $e, $o;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      $o.push("<div class='" + (['row-half', "" + ($e($c((!this.hasNextPage ? "hidden" : void 0))))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "'>\n  <button class='" + (['button', 'secondary', 'small', 'js-load-more', 'pagination-button', "" + ($e($c(((this.collection.editingProject() || this.loading) ? "disabled" : void 0))))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "'>\n    Load more\n  </button>\n</div>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./app/javascript/backbone/projects/templates/pagination_button.js.hamlc
// module id = 1533
// module chunks = 18